<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :modal="false" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="规格名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="规格编号：" prop="sku">
                <el-input v-model="model.sku"></el-input>
            </el-form-item>
            <el-form-item label="原价：" prop="y_price">
                <el-input v-model="model.y_price"></el-input>
            </el-form-item>
            <el-form-item label="实际价格：" prop="price">
                <el-input v-model="model.price"></el-input>
            </el-form-item>
            <el-form-item label="团购价格：" prop="price_tuan">
                <el-input v-model="model.price_tuan"></el-input>
            </el-form-item>
            <el-form-item label="赠送积分" prop="point">
                <el-input v-model.number="model.point"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
            <el-form-item label="图片：" prop="img" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.img" :src="model.img" class="upImg" style="width: 160px;height: 160px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 160x;height: 160px;line-height: 160px"></i>
                </el-upload>
                <span class="tips">建议尺寸：200px * 200px</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById } from '@/api/common'
import config from '@/config'

export default {
    name: 'goodsSpecEdit',
    mixins: [editutil],
    props: {
        goods_id: {
            type: Number,
            default() {
                return 0;
            }
        },
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.resetModel(this.form_name);
                this.loadData();
            }
        }
    },
    data() {
        return {
            model: {
                goods_id: '',
                name: '',
                sku: '',
                y_price: '',
                price: '',
                price_tuan: '',
                order_index: '',
                img: '',
            },
            getObj:{
                url:'/api/admin/goodsspec/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                name: [
                    {required: true, message: '规格名称不能为空', trigger: 'blur'},
                ],
                sku: [
                    {required: true, message: '规格编号不能为空', trigger: 'blur'},
                ],
                y_price: [
                    {required: true, message: '原价不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                price: [
                    {required: true, message: '实际价格不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                point: [
                    {required: true, message: '积分不能为空', trigger: 'blur'},
                    {type: 'number', message: '积分必须是数字值', trigger: 'blur'}
                ],
                price_tuan: [
                    {required: true, message: '团购不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "goods",
            },
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }else{
                this.model.goods_id = this.goods_id
            }
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/goodsspec/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.img = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
    }
};
</script>